// SONG SCHEMA
export const songs = [
  {
    title: "What is Love?",
    artist: "Twice",
    music_url: "https://audio.jukehost.co.uk/IGYozUMdodb9Q45YWlILUjxFvJ8gsZ6g",
    album_url:
      "https://www.kpopusaonline.com/wp-content/uploads/2019/11/232.1.jpg",
    lyrics: [
      {
        line: "",
        time: -1,
      },
      {
        line: "What is love?",
        time: 7220,
      },
      {
        line: "",
        time: 8430,
      },
      {
        line: "매일같이 영화 속에서나",
        time: 11220,
      },
      {
        line: "책 속에서나 드라마 속에서 사랑을 느껴",
        time: 13440,
      },
      {
        line: "Mmm, 사랑을 배워",
        time: 17880,
      },
      {
        line: "내 일처럼 자꾸 가슴이 뛰어",
        time: 22380,
      },
      {
        line: "두근두근거려 설레임에 부풀어 올라",
        time: 24670,
      },
      {
        line: "Mmm, 궁금해서 미칠 것만 같아",
        time: 29740,
      },
      {
        line: "",
        time: 33800,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 34310,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 36090,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 40150,
      },
      {
        line: "",
        time: 44080,
      },
      {
        line: "I wanna know",
        time: 44590,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 45030,
      },
      {
        line: "I wanna know",
        time: 47310,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 48010,
      },
      {
        line: "I wanna know know know know",
        time: 50360,
      },
      {
        line: "What is love?",
        time: 52140,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 53020,
      },
      {
        line: "I wanna know",
        time: 55630,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 56390,
      },
      {
        line: "I wanna know",
        time: 58730,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 59560,
      },
      {
        line: "I wanna know know know know",
        time: 61720,
      },
      {
        line: "What is love?",
        time: 63490,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 64450,
      },
      {
        line: "",
        time: 67300,
      },
      {
        line: "지금 이런 상상만으로도",
        time: 67680,
      },
      {
        line: "떠올려만 봐도 가슴이 터질 것 같은데",
        time: 70600,
      },
      {
        line: "Mmm, 이렇게 좋은데",
        time: 74340,
      },
      {
        line: "만일 언젠가 진짜로 내게",
        time: 78780,
      },
      {
        line: "사랑이 올 때 난 울어버릴지도 몰라",
        time: 81320,
      },
      {
        line: "Mmm, 정말 궁금해 미칠 것만 같아",
        time: 85820,
      },
      {
        line: "",
        time: 89950,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 90650,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 92550,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 96920,
      },
      {
        line: "",
        time: 100480,
      },
      {
        line: "I wanna know",
        time: 100990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 101750,
      },
      {
        line: "I wanna know",
        time: 103910,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 104480,
      },
      {
        line: "I wanna know know know know",
        time: 106760,
      },
      {
        line: "What is love?",
        time: 108530,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 109680,
      },
      {
        line: "I wanna know",
        time: 112090,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 112910,
      },
      {
        line: "I wanna know",
        time: 115010,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 115580,
      },
      {
        line: "{All} I wanna know know know know",
        time: 118180,
      },
      {
        line: "What is love?",
        time: 119890,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 120910,
      },
      {
        line: "",
        time: 123890,
      },
      {
        line: "지금 세상 어느 곳에 살고 있는지",
        time: 124330,
      },
      {
        line: "도대체 언제쯤 나와 만나게 될는지",
        time: 126680,
      },
      {
        line: "언제 어떻게 우리의 인연은",
        time: 129340,
      },
      {
        line: "시작될는지 모르지만 느낌이 어쩐지",
        time: 131550,
      },
      {
        line: "진짜 좋을 것 같아 왠지",
        time: 135100,
      },
      {
        line: "영화 드라마보다도 더 멋진 (멋진)",
        time: 137830,
      },
      {
        line: "사랑이 올 거야 내 예감 언제나 맞지 (Ooh-ooh)",
        time: 140620,
      },
      {
        line: "어서 나타나봐 나는 다 준비가 됐지 ready",
        time: 143290,
      },
      {
        line: "",
        time: 146330,
      },
      {
        line: "어디 있을까?",
        time: 146840,
      },
      {
        line: "찾아낼 거야",
        time: 148170,
      },
      {
        line: "어디 있을까?",
        time: 149380,
      },
      {
        line: "보고 싶어 죽겠어",
        time: 151090,
      },
      {
        line: "더 이상 참을 수 없을 것만 같아",
        time: 153060,
      },
      {
        line: "",
        time: 156990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 157500,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 160040,
      },
      {
        line: "I wanna know know know know",
        time: 163080,
      },
      {
        line: "What is love?",
        time: 164980,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 165930,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 168470,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 171710,
      },
      {
        line: "I wanna know know know know",
        time: 174630,
      },
      {
        line: "What is love?",
        time: 176150,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 177350,
      },
      {
        line: "",
        time: 180460,
      },
      {
        line: "I wanna know, I wanna know",
        time: 180840,
      },
      {
        line: "I wanna know know know know",
        time: 185730,
      },
      {
        line: "What is love?",
        time: 187630,
      },
      {
        line: "I wanna know, I wanna know",
        time: 188580,
      },
      {
        line: "I wanna know know know know",
        time: 197280,
      },
      {
        line: "What is love?",
        time: 199110,
      },
      {
        line: "I wanna know",
        time: 202600,
      },
      {
        line: "",
        time: 203940,
      },
    ],
  },
  {
    title: "Gangnam Style",
    artist: "Psy",
    music_url: "https://audio.jukehost.co.uk/TN61TR7m3RzTHnOShoCBvfMatMIuV4qR",
    album_url:
      "https://e-cdn-images.dzcdn.net/images/cover/45e4493fcc15997085491debddcf049e/264x264-000000-80-0-0.jpg",

    lyrics: [
      {
        time: 9970,
        line: "오빤 강남 스타일",
      },
      {
        time: 13960,
        line: "강남스타일",
      },
      {
        time: 18710,
        line: "낮에는 따사로운 인간적인 여자",
      },
      {
        time: 22010,
        line: "커피 한잔의 여유를 아는 품격 있는 여자",
      },
      {
        time: 25600,
        line: "밤이 오면 심장이 뜨거워지는 여자",
      },
      {
        time: 29160,
        line: "그런 반전 있는 여자",
      },
      {
        time: 32820,
        line: "나는 사나이",
      },
      {
        time: 34170,
        line: "낮에는 너만큼 따사로운 그런 사나이",
      },
      {
        time: 37740,
        line: "커피 식기도 전에 원샷 때리는 사나이",
      },
      {
        time: 41380,
        line: "밤이 오면 심장이 터져버리는 사나이",
      },
      {
        time: 44970,
        line: "그런 사나이",
      },
      {
        time: 47320,
        line: "아름다워 사랑스러워",
      },
      {
        time: 51040,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 54450,
        line: "아름다워 사랑스러워",
      },
      {
        time: 58060,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 61770,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 69670,
        line: "오빤 강남스타일",
      },
      {
        time: 73750,
        line: "강남스타일",
      },
      {
        time: 75140,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 81110,
        line: "강남스타일",
      },
      {
        time: 82210,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 85890,
        line: "Eh- Sexy Lady",
      },
      {
        time: 89560,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 93120,
        line: "Eh- Sexy Lady",
      },
      {
        time: 96760,
        line: "오 오 오 오",
      },
      {
        time: 100470,
        line: "정숙해 보이지만 놀 땐 노는 여자",
      },
      {
        time: 103890,
        line: "이때다 싶으면 묶었던 머리 푸는 여자",
      },
      {
        time: 107290,
        line: "가렸지만 웬만한 노출보다 야한 여자",
      },
      {
        time: 110960,
        line: "그런 감각적인 여자",
      },
      {
        time: 114600,
        line: "나는 사나이",
      },
      {
        time: 116130,
        line: "점잖아 보이지만 놀 땐 노는 사나이",
      },
      {
        time: 119380,
        line: "때가 되면 완전 미쳐버리는 사나이",
      },
      {
        time: 123010,
        line: "근육보다 사상이 울퉁불퉁한 사나이",
      },
      {
        time: 126800,
        line: "그런 사나이",
      },
      {
        time: 129340,
        line: "아름다워 사랑스러워",
      },
      {
        time: 132670,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 136310,
        line: "아름다워 사랑스러워",
      },
      {
        time: 140020,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 143600,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 151610,
        line: "오빤 강남스타일",
      },
      {
        time: 155550,
        line: "강남스타일",
      },
      {
        time: 156820,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 162880,
        line: "강남스타일",
      },
      {
        time: 164150,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 167720,
        line: "Eh- Sexy Lady",
      },
      {
        time: 171400,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 174870,
        line: "Eh- Sexy Lady",
      },
      {
        time: 178650,
        line: "오 오 오 오",
      },
      {
        time: 182300,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 185360,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 189420,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 192560,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 195610,
        line: "You know what I'm saying",
      },
      {
        time: 197230,
        line: "오빤 강남스타일",
      },
      {
        time: 198840,
        line: "Eh- Sexy Lady",
      },
      {
        time: 204020,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 207650,
        line: "Eh- Sexy Lady",
      },
      {
        time: 211380,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 216760,
        line: "",
      },
    ],
  },
  {
    title: "Baby Shark",
    artist: "Pinkfong",
    music_url: "https://audio.jukehost.co.uk/IGYozUMdodb9Q45YWlILUjxFvJ8gsZ6g",
    album_url:
      "https://img.sbs.co.kr/newsnet/etv/upload/2020/11/12/30000655562_1280.jpg",
    lyrics: [
      {
        line: "",
        time: -1,
      },
      {
        line: "What is love?",
        time: 7220,
      },
      {
        line: "",
        time: 8430,
      },
      {
        line: "매일같이 영화 속에서나",
        time: 11220,
      },
      {
        line: "책 속에서나 드라마 속에서 사랑을 느껴",
        time: 13440,
      },
      {
        line: "Mmm, 사랑을 배워",
        time: 17880,
      },
      {
        line: "내 일처럼 자꾸 가슴이 뛰어",
        time: 22380,
      },
      {
        line: "두근두근거려 설레임에 부풀어 올라",
        time: 24670,
      },
      {
        line: "Mmm, 궁금해서 미칠 것만 같아",
        time: 29740,
      },
      {
        line: "",
        time: 33800,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 34310,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 36090,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 40150,
      },
      {
        line: "",
        time: 44080,
      },
      {
        line: "I wanna know",
        time: 44590,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 45030,
      },
      {
        line: "I wanna know",
        time: 47310,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 48010,
      },
      {
        line: "I wanna know know know know",
        time: 50360,
      },
      {
        line: "What is love?",
        time: 52140,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 53020,
      },
      {
        line: "I wanna know",
        time: 55630,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 56390,
      },
      {
        line: "I wanna know",
        time: 58730,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 59560,
      },
      {
        line: "I wanna know know know know",
        time: 61720,
      },
      {
        line: "What is love?",
        time: 63490,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 64450,
      },
      {
        line: "",
        time: 67300,
      },
      {
        line: "지금 이런 상상만으로도",
        time: 67680,
      },
      {
        line: "떠올려만 봐도 가슴이 터질 것 같은데",
        time: 70600,
      },
      {
        line: "Mmm, 이렇게 좋은데",
        time: 74340,
      },
      {
        line: "만일 언젠가 진짜로 내게",
        time: 78780,
      },
      {
        line: "사랑이 올 때 난 울어버릴지도 몰라",
        time: 81320,
      },
      {
        line: "Mmm, 정말 궁금해 미칠 것만 같아",
        time: 85820,
      },
      {
        line: "",
        time: 89950,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 90650,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 92550,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 96920,
      },
      {
        line: "",
        time: 100480,
      },
      {
        line: "I wanna know",
        time: 100990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 101750,
      },
      {
        line: "I wanna know",
        time: 103910,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 104480,
      },
      {
        line: "I wanna know know know know",
        time: 106760,
      },
      {
        line: "What is love?",
        time: 108530,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 109680,
      },
      {
        line: "I wanna know",
        time: 112090,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 112910,
      },
      {
        line: "I wanna know",
        time: 115010,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 115580,
      },
      {
        line: "{All} I wanna know know know know",
        time: 118180,
      },
      {
        line: "What is love?",
        time: 119890,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 120910,
      },
      {
        line: "",
        time: 123890,
      },
      {
        line: "지금 세상 어느 곳에 살고 있는지",
        time: 124330,
      },
      {
        line: "도대체 언제쯤 나와 만나게 될는지",
        time: 126680,
      },
      {
        line: "언제 어떻게 우리의 인연은",
        time: 129340,
      },
      {
        line: "시작될는지 모르지만 느낌이 어쩐지",
        time: 131550,
      },
      {
        line: "진짜 좋을 것 같아 왠지",
        time: 135100,
      },
      {
        line: "영화 드라마보다도 더 멋진 (멋진)",
        time: 137830,
      },
      {
        line: "사랑이 올 거야 내 예감 언제나 맞지 (Ooh-ooh)",
        time: 140620,
      },
      {
        line: "어서 나타나봐 나는 다 준비가 됐지 ready",
        time: 143290,
      },
      {
        line: "",
        time: 146330,
      },
      {
        line: "어디 있을까?",
        time: 146840,
      },
      {
        line: "찾아낼 거야",
        time: 148170,
      },
      {
        line: "어디 있을까?",
        time: 149380,
      },
      {
        line: "보고 싶어 죽겠어",
        time: 151090,
      },
      {
        line: "더 이상 참을 수 없을 것만 같아",
        time: 153060,
      },
      {
        line: "",
        time: 156990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 157500,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 160040,
      },
      {
        line: "I wanna know know know know",
        time: 163080,
      },
      {
        line: "What is love?",
        time: 164980,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 165930,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 168470,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 171710,
      },
      {
        line: "I wanna know know know know",
        time: 174630,
      },
      {
        line: "What is love?",
        time: 176150,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 177350,
      },
      {
        line: "",
        time: 180460,
      },
      {
        line: "I wanna know, I wanna know",
        time: 180840,
      },
      {
        line: "I wanna know know know know",
        time: 185730,
      },
      {
        line: "What is love?",
        time: 187630,
      },
      {
        line: "I wanna know, I wanna know",
        time: 188580,
      },
      {
        line: "I wanna know know know know",
        time: 197280,
      },
      {
        line: "What is love?",
        time: 199110,
      },
      {
        line: "I wanna know",
        time: 202600,
      },
      {
        line: "",
        time: 203940,
      },
    ],
  },
  {
    title: "Korean National Anthem",
    artist: "Ahn ChangHo",
    music_url: "https://audio.jukehost.co.uk/TN61TR7m3RzTHnOShoCBvfMatMIuV4qR",
    album_url:
      "https://gongu.copyright.or.kr/gongu/wrt/cmmn/wrtFileImageView.do?wrtSn=13222033&filePath=L2Rpc2sxL25ld2RhdGEvMjAxOS8yMS9DTFMxMDAwNC8xMzIyMjAzM19XUlRfMjAxOTExMjFfMQ==&thumbAt=Y&thumbSe=b_tbumb&wrtTy=10004",

    lyrics: [
      {
        time: 9970,
        line: "오빤 강남 스타일",
      },
      {
        time: 13960,
        line: "강남스타일",
      },
      {
        time: 18710,
        line: "낮에는 따사로운 인간적인 여자",
      },
      {
        time: 22010,
        line: "커피 한잔의 여유를 아는 품격 있는 여자",
      },
      {
        time: 25600,
        line: "밤이 오면 심장이 뜨거워지는 여자",
      },
      {
        time: 29160,
        line: "그런 반전 있는 여자",
      },
      {
        time: 32820,
        line: "나는 사나이",
      },
      {
        time: 34170,
        line: "낮에는 너만큼 따사로운 그런 사나이",
      },
      {
        time: 37740,
        line: "커피 식기도 전에 원샷 때리는 사나이",
      },
      {
        time: 41380,
        line: "밤이 오면 심장이 터져버리는 사나이",
      },
      {
        time: 44970,
        line: "그런 사나이",
      },
      {
        time: 47320,
        line: "아름다워 사랑스러워",
      },
      {
        time: 51040,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 54450,
        line: "아름다워 사랑스러워",
      },
      {
        time: 58060,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 61770,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 69670,
        line: "오빤 강남스타일",
      },
      {
        time: 73750,
        line: "강남스타일",
      },
      {
        time: 75140,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 81110,
        line: "강남스타일",
      },
      {
        time: 82210,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 85890,
        line: "Eh- Sexy Lady",
      },
      {
        time: 89560,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 93120,
        line: "Eh- Sexy Lady",
      },
      {
        time: 96760,
        line: "오 오 오 오",
      },
      {
        time: 100470,
        line: "정숙해 보이지만 놀 땐 노는 여자",
      },
      {
        time: 103890,
        line: "이때다 싶으면 묶었던 머리 푸는 여자",
      },
      {
        time: 107290,
        line: "가렸지만 웬만한 노출보다 야한 여자",
      },
      {
        time: 110960,
        line: "그런 감각적인 여자",
      },
      {
        time: 114600,
        line: "나는 사나이",
      },
      {
        time: 116130,
        line: "점잖아 보이지만 놀 땐 노는 사나이",
      },
      {
        time: 119380,
        line: "때가 되면 완전 미쳐버리는 사나이",
      },
      {
        time: 123010,
        line: "근육보다 사상이 울퉁불퉁한 사나이",
      },
      {
        time: 126800,
        line: "그런 사나이",
      },
      {
        time: 129340,
        line: "아름다워 사랑스러워",
      },
      {
        time: 132670,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 136310,
        line: "아름다워 사랑스러워",
      },
      {
        time: 140020,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 143600,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 151610,
        line: "오빤 강남스타일",
      },
      {
        time: 155550,
        line: "강남스타일",
      },
      {
        time: 156820,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 162880,
        line: "강남스타일",
      },
      {
        time: 164150,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 167720,
        line: "Eh- Sexy Lady",
      },
      {
        time: 171400,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 174870,
        line: "Eh- Sexy Lady",
      },
      {
        time: 178650,
        line: "오 오 오 오",
      },
      {
        time: 182300,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 185360,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 189420,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 192560,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 195610,
        line: "You know what I'm saying",
      },
      {
        time: 197230,
        line: "오빤 강남스타일",
      },
      {
        time: 198840,
        line: "Eh- Sexy Lady",
      },
      {
        time: 204020,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 207650,
        line: "Eh- Sexy Lady",
      },
      {
        time: 211380,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 216760,
        line: "",
      },
    ],
  },
  {
    title: "Arirang",
    artist: "Unknown",
    music_url: "https://audio.jukehost.co.uk/IGYozUMdodb9Q45YWlILUjxFvJ8gsZ6g",
    album_url:
      "https://i1.sndcdn.com/artworks-000187371096-4dh78z-t500x500.jpg",
    lyrics: [
      {
        line: "",
        time: -1,
      },
      {
        line: "What is love?",
        time: 7220,
      },
      {
        line: "",
        time: 8430,
      },
      {
        line: "매일같이 영화 속에서나",
        time: 11220,
      },
      {
        line: "책 속에서나 드라마 속에서 사랑을 느껴",
        time: 13440,
      },
      {
        line: "Mmm, 사랑을 배워",
        time: 17880,
      },
      {
        line: "내 일처럼 자꾸 가슴이 뛰어",
        time: 22380,
      },
      {
        line: "두근두근거려 설레임에 부풀어 올라",
        time: 24670,
      },
      {
        line: "Mmm, 궁금해서 미칠 것만 같아",
        time: 29740,
      },
      {
        line: "",
        time: 33800,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 34310,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 36090,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 40150,
      },
      {
        line: "",
        time: 44080,
      },
      {
        line: "I wanna know",
        time: 44590,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 45030,
      },
      {
        line: "I wanna know",
        time: 47310,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 48010,
      },
      {
        line: "I wanna know know know know",
        time: 50360,
      },
      {
        line: "What is love?",
        time: 52140,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 53020,
      },
      {
        line: "I wanna know",
        time: 55630,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 56390,
      },
      {
        line: "I wanna know",
        time: 58730,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 59560,
      },
      {
        line: "I wanna know know know know",
        time: 61720,
      },
      {
        line: "What is love?",
        time: 63490,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 64450,
      },
      {
        line: "",
        time: 67300,
      },
      {
        line: "지금 이런 상상만으로도",
        time: 67680,
      },
      {
        line: "떠올려만 봐도 가슴이 터질 것 같은데",
        time: 70600,
      },
      {
        line: "Mmm, 이렇게 좋은데",
        time: 74340,
      },
      {
        line: "만일 언젠가 진짜로 내게",
        time: 78780,
      },
      {
        line: "사랑이 올 때 난 울어버릴지도 몰라",
        time: 81320,
      },
      {
        line: "Mmm, 정말 궁금해 미칠 것만 같아",
        time: 85820,
      },
      {
        line: "",
        time: 89950,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 90650,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 92550,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 96920,
      },
      {
        line: "",
        time: 100480,
      },
      {
        line: "I wanna know",
        time: 100990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 101750,
      },
      {
        line: "I wanna know",
        time: 103910,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 104480,
      },
      {
        line: "I wanna know know know know",
        time: 106760,
      },
      {
        line: "What is love?",
        time: 108530,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 109680,
      },
      {
        line: "I wanna know",
        time: 112090,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 112910,
      },
      {
        line: "I wanna know",
        time: 115010,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 115580,
      },
      {
        line: "{All} I wanna know know know know",
        time: 118180,
      },
      {
        line: "What is love?",
        time: 119890,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 120910,
      },
      {
        line: "",
        time: 123890,
      },
      {
        line: "지금 세상 어느 곳에 살고 있는지",
        time: 124330,
      },
      {
        line: "도대체 언제쯤 나와 만나게 될는지",
        time: 126680,
      },
      {
        line: "언제 어떻게 우리의 인연은",
        time: 129340,
      },
      {
        line: "시작될는지 모르지만 느낌이 어쩐지",
        time: 131550,
      },
      {
        line: "진짜 좋을 것 같아 왠지",
        time: 135100,
      },
      {
        line: "영화 드라마보다도 더 멋진 (멋진)",
        time: 137830,
      },
      {
        line: "사랑이 올 거야 내 예감 언제나 맞지 (Ooh-ooh)",
        time: 140620,
      },
      {
        line: "어서 나타나봐 나는 다 준비가 됐지 ready",
        time: 143290,
      },
      {
        line: "",
        time: 146330,
      },
      {
        line: "어디 있을까?",
        time: 146840,
      },
      {
        line: "찾아낼 거야",
        time: 148170,
      },
      {
        line: "어디 있을까?",
        time: 149380,
      },
      {
        line: "보고 싶어 죽겠어",
        time: 151090,
      },
      {
        line: "더 이상 참을 수 없을 것만 같아",
        time: 153060,
      },
      {
        line: "",
        time: 156990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 157500,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 160040,
      },
      {
        line: "I wanna know know know know",
        time: 163080,
      },
      {
        line: "What is love?",
        time: 164980,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 165930,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 168470,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 171710,
      },
      {
        line: "I wanna know know know know",
        time: 174630,
      },
      {
        line: "What is love?",
        time: 176150,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 177350,
      },
      {
        line: "",
        time: 180460,
      },
      {
        line: "I wanna know, I wanna know",
        time: 180840,
      },
      {
        line: "I wanna know know know know",
        time: 185730,
      },
      {
        line: "What is love?",
        time: 187630,
      },
      {
        line: "I wanna know, I wanna know",
        time: 188580,
      },
      {
        line: "I wanna know know know know",
        time: 197280,
      },
      {
        line: "What is love?",
        time: 199110,
      },
      {
        line: "I wanna know",
        time: 202600,
      },
      {
        line: "",
        time: 203940,
      },
    ],
  },
  {
    title: "Hanguel Song",
    artist: "Unknown",
    music_url: "https://audio.jukehost.co.uk/TN61TR7m3RzTHnOShoCBvfMatMIuV4qR",
    album_url:
      "https://i.ibb.co/6HP6txT/MV5-BZWFk-ZWNk-ZWMt-MTBi-MS00-Mjc2-LWI5-MDYt-Njk0-Zm-Vk-Nz-E5-NGY1-Xk-Ey-Xk-Fqc-Gde-QXVy-MTE0-MTc4-M.jpg",

    lyrics: [
      {
        time: 9970,
        line: "오빤 강남 스타일",
      },
      {
        time: 13960,
        line: "강남스타일",
      },
      {
        time: 18710,
        line: "낮에는 따사로운 인간적인 여자",
      },
      {
        time: 22010,
        line: "커피 한잔의 여유를 아는 품격 있는 여자",
      },
      {
        time: 25600,
        line: "밤이 오면 심장이 뜨거워지는 여자",
      },
      {
        time: 29160,
        line: "그런 반전 있는 여자",
      },
      {
        time: 32820,
        line: "나는 사나이",
      },
      {
        time: 34170,
        line: "낮에는 너만큼 따사로운 그런 사나이",
      },
      {
        time: 37740,
        line: "커피 식기도 전에 원샷 때리는 사나이",
      },
      {
        time: 41380,
        line: "밤이 오면 심장이 터져버리는 사나이",
      },
      {
        time: 44970,
        line: "그런 사나이",
      },
      {
        time: 47320,
        line: "아름다워 사랑스러워",
      },
      {
        time: 51040,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 54450,
        line: "아름다워 사랑스러워",
      },
      {
        time: 58060,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 61770,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 69670,
        line: "오빤 강남스타일",
      },
      {
        time: 73750,
        line: "강남스타일",
      },
      {
        time: 75140,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 81110,
        line: "강남스타일",
      },
      {
        time: 82210,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 85890,
        line: "Eh- Sexy Lady",
      },
      {
        time: 89560,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 93120,
        line: "Eh- Sexy Lady",
      },
      {
        time: 96760,
        line: "오 오 오 오",
      },
      {
        time: 100470,
        line: "정숙해 보이지만 놀 땐 노는 여자",
      },
      {
        time: 103890,
        line: "이때다 싶으면 묶었던 머리 푸는 여자",
      },
      {
        time: 107290,
        line: "가렸지만 웬만한 노출보다 야한 여자",
      },
      {
        time: 110960,
        line: "그런 감각적인 여자",
      },
      {
        time: 114600,
        line: "나는 사나이",
      },
      {
        time: 116130,
        line: "점잖아 보이지만 놀 땐 노는 사나이",
      },
      {
        time: 119380,
        line: "때가 되면 완전 미쳐버리는 사나이",
      },
      {
        time: 123010,
        line: "근육보다 사상이 울퉁불퉁한 사나이",
      },
      {
        time: 126800,
        line: "그런 사나이",
      },
      {
        time: 129340,
        line: "아름다워 사랑스러워",
      },
      {
        time: 132670,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 136310,
        line: "아름다워 사랑스러워",
      },
      {
        time: 140020,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 143600,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 151610,
        line: "오빤 강남스타일",
      },
      {
        time: 155550,
        line: "강남스타일",
      },
      {
        time: 156820,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 162880,
        line: "강남스타일",
      },
      {
        time: 164150,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 167720,
        line: "Eh- Sexy Lady",
      },
      {
        time: 171400,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 174870,
        line: "Eh- Sexy Lady",
      },
      {
        time: 178650,
        line: "오 오 오 오",
      },
      {
        time: 182300,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 185360,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 189420,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 192560,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 195610,
        line: "You know what I'm saying",
      },
      {
        time: 197230,
        line: "오빤 강남스타일",
      },
      {
        time: 198840,
        line: "Eh- Sexy Lady",
      },
      {
        time: 204020,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 207650,
        line: "Eh- Sexy Lady",
      },
      {
        time: 211380,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 216760,
        line: "",
      },
    ],
  },
  {
    title: "Song For You",
    artist: "SUPER JUNIOR",
    music_url: "https://audio.jukehost.co.uk/IGYozUMdodb9Q45YWlILUjxFvJ8gsZ6g",
    album_url:
      "https://image.genie.co.kr/Y/IMAGE/IMG_ALBUM/080/271/681/80271681_1319426634827_1_600x600.JPG/dims/resize/Q_80,0",
    lyrics: [
      {
        line: "",
        time: -1,
      },
      {
        line: "What is love?",
        time: 7220,
      },
      {
        line: "",
        time: 8430,
      },
      {
        line: "매일같이 영화 속에서나",
        time: 11220,
      },
      {
        line: "책 속에서나 드라마 속에서 사랑을 느껴",
        time: 13440,
      },
      {
        line: "Mmm, 사랑을 배워",
        time: 17880,
      },
      {
        line: "내 일처럼 자꾸 가슴이 뛰어",
        time: 22380,
      },
      {
        line: "두근두근거려 설레임에 부풀어 올라",
        time: 24670,
      },
      {
        line: "Mmm, 궁금해서 미칠 것만 같아",
        time: 29740,
      },
      {
        line: "",
        time: 33800,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 34310,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 36090,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 40150,
      },
      {
        line: "",
        time: 44080,
      },
      {
        line: "I wanna know",
        time: 44590,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 45030,
      },
      {
        line: "I wanna know",
        time: 47310,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 48010,
      },
      {
        line: "I wanna know know know know",
        time: 50360,
      },
      {
        line: "What is love?",
        time: 52140,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 53020,
      },
      {
        line: "I wanna know",
        time: 55630,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 56390,
      },
      {
        line: "I wanna know",
        time: 58730,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 59560,
      },
      {
        line: "I wanna know know know know",
        time: 61720,
      },
      {
        line: "What is love?",
        time: 63490,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 64450,
      },
      {
        line: "",
        time: 67300,
      },
      {
        line: "지금 이런 상상만으로도",
        time: 67680,
      },
      {
        line: "떠올려만 봐도 가슴이 터질 것 같은데",
        time: 70600,
      },
      {
        line: "Mmm, 이렇게 좋은데",
        time: 74340,
      },
      {
        line: "만일 언젠가 진짜로 내게",
        time: 78780,
      },
      {
        line: "사랑이 올 때 난 울어버릴지도 몰라",
        time: 81320,
      },
      {
        line: "Mmm, 정말 궁금해 미칠 것만 같아",
        time: 85820,
      },
      {
        line: "",
        time: 89950,
      },
      {
        line: "Ooh, 언젠간 내게도",
        time: 90650,
      },
      {
        line: "이런 일이 실제로 일어날까",
        time: 92550,
      },
      {
        line: "그게 언제쯤일까? 어떤 사람일까?",
        time: 96920,
      },
      {
        line: "",
        time: 100480,
      },
      {
        line: "I wanna know",
        time: 100990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 101750,
      },
      {
        line: "I wanna know",
        time: 103910,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 104480,
      },
      {
        line: "I wanna know know know know",
        time: 106760,
      },
      {
        line: "What is love?",
        time: 108530,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 109680,
      },
      {
        line: "I wanna know",
        time: 112090,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 112910,
      },
      {
        line: "I wanna know",
        time: 115010,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 115580,
      },
      {
        line: "{All} I wanna know know know know",
        time: 118180,
      },
      {
        line: "What is love?",
        time: 119890,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 120910,
      },
      {
        line: "",
        time: 123890,
      },
      {
        line: "지금 세상 어느 곳에 살고 있는지",
        time: 124330,
      },
      {
        line: "도대체 언제쯤 나와 만나게 될는지",
        time: 126680,
      },
      {
        line: "언제 어떻게 우리의 인연은",
        time: 129340,
      },
      {
        line: "시작될는지 모르지만 느낌이 어쩐지",
        time: 131550,
      },
      {
        line: "진짜 좋을 것 같아 왠지",
        time: 135100,
      },
      {
        line: "영화 드라마보다도 더 멋진 (멋진)",
        time: 137830,
      },
      {
        line: "사랑이 올 거야 내 예감 언제나 맞지 (Ooh-ooh)",
        time: 140620,
      },
      {
        line: "어서 나타나봐 나는 다 준비가 됐지 ready",
        time: 143290,
      },
      {
        line: "",
        time: 146330,
      },
      {
        line: "어디 있을까?",
        time: 146840,
      },
      {
        line: "찾아낼 거야",
        time: 148170,
      },
      {
        line: "어디 있을까?",
        time: 149380,
      },
      {
        line: "보고 싶어 죽겠어",
        time: 151090,
      },
      {
        line: "더 이상 참을 수 없을 것만 같아",
        time: 153060,
      },
      {
        line: "",
        time: 156990,
      },
      {
        line: "사탕처럼 달콤하다는데",
        time: 157500,
      },
      {
        line: "하늘을 나는 것 같다는데",
        time: 160040,
      },
      {
        line: "I wanna know know know know",
        time: 163080,
      },
      {
        line: "What is love?",
        time: 164980,
      },
      {
        line: "사랑이 어떤 느낌인지?",
        time: 165930,
      },
      {
        line: "하루 종일 웃고 있다는데",
        time: 168470,
      },
      {
        line: "세상이 다 아름답다는데",
        time: 171710,
      },
      {
        line: "I wanna know know know know",
        time: 174630,
      },
      {
        line: "What is love?",
        time: 176150,
      },
      {
        line: "언젠간 나에게도 사랑이 올까?",
        time: 177350,
      },
      {
        line: "",
        time: 180460,
      },
      {
        line: "I wanna know, I wanna know",
        time: 180840,
      },
      {
        line: "I wanna know know know know",
        time: 185730,
      },
      {
        line: "What is love?",
        time: 187630,
      },
      {
        line: "I wanna know, I wanna know",
        time: 188580,
      },
      {
        line: "I wanna know know know know",
        time: 197280,
      },
      {
        line: "What is love?",
        time: 199110,
      },
      {
        line: "I wanna know",
        time: 202600,
      },
      {
        line: "",
        time: 203940,
      },
    ],
  },
  {
    title: "Colt",
    artist: "KangChan",
    music_url: "https://audio.jukehost.co.uk/TN61TR7m3RzTHnOShoCBvfMatMIuV4qR",
    album_url:
      "https://image.genie.co.kr/Y/IMAGE/IMG_ALBUM/080/160/161/80160161_1_600x600.JPG/dims/resize/Q_80,0",

    lyrics: [
      {
        time: 9970,
        line: "오빤 강남 스타일",
      },
      {
        time: 13960,
        line: "강남스타일",
      },
      {
        time: 18710,
        line: "낮에는 따사로운 인간적인 여자",
      },
      {
        time: 22010,
        line: "커피 한잔의 여유를 아는 품격 있는 여자",
      },
      {
        time: 25600,
        line: "밤이 오면 심장이 뜨거워지는 여자",
      },
      {
        time: 29160,
        line: "그런 반전 있는 여자",
      },
      {
        time: 32820,
        line: "나는 사나이",
      },
      {
        time: 34170,
        line: "낮에는 너만큼 따사로운 그런 사나이",
      },
      {
        time: 37740,
        line: "커피 식기도 전에 원샷 때리는 사나이",
      },
      {
        time: 41380,
        line: "밤이 오면 심장이 터져버리는 사나이",
      },
      {
        time: 44970,
        line: "그런 사나이",
      },
      {
        time: 47320,
        line: "아름다워 사랑스러워",
      },
      {
        time: 51040,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 54450,
        line: "아름다워 사랑스러워",
      },
      {
        time: 58060,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 61770,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 69670,
        line: "오빤 강남스타일",
      },
      {
        time: 73750,
        line: "강남스타일",
      },
      {
        time: 75140,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 81110,
        line: "강남스타일",
      },
      {
        time: 82210,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 85890,
        line: "Eh- Sexy Lady",
      },
      {
        time: 89560,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 93120,
        line: "Eh- Sexy Lady",
      },
      {
        time: 96760,
        line: "오 오 오 오",
      },
      {
        time: 100470,
        line: "정숙해 보이지만 놀 땐 노는 여자",
      },
      {
        time: 103890,
        line: "이때다 싶으면 묶었던 머리 푸는 여자",
      },
      {
        time: 107290,
        line: "가렸지만 웬만한 노출보다 야한 여자",
      },
      {
        time: 110960,
        line: "그런 감각적인 여자",
      },
      {
        time: 114600,
        line: "나는 사나이",
      },
      {
        time: 116130,
        line: "점잖아 보이지만 놀 땐 노는 사나이",
      },
      {
        time: 119380,
        line: "때가 되면 완전 미쳐버리는 사나이",
      },
      {
        time: 123010,
        line: "근육보다 사상이 울퉁불퉁한 사나이",
      },
      {
        time: 126800,
        line: "그런 사나이",
      },
      {
        time: 129340,
        line: "아름다워 사랑스러워",
      },
      {
        time: 132670,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 136310,
        line: "아름다워 사랑스러워",
      },
      {
        time: 140020,
        line: "그래 너 hey 그래 바로 너 hey",
      },
      {
        time: 143600,
        line: "지금부터 갈 데까지 가볼까",
      },
      {
        time: 151610,
        line: "오빤 강남스타일",
      },
      {
        time: 155550,
        line: "강남스타일",
      },
      {
        time: 156820,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 162880,
        line: "강남스타일",
      },
      {
        time: 164150,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 167720,
        line: "Eh- Sexy Lady",
      },
      {
        time: 171400,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 174870,
        line: "Eh- Sexy Lady",
      },
      {
        time: 178650,
        line: "오 오 오 오",
      },
      {
        time: 182300,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 185360,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 189420,
        line: "뛰는 놈 그 위에 나는 놈",
      },
      {
        time: 192560,
        line: "baby baby 나는 뭘 좀 아는 놈",
      },
      {
        time: 195610,
        line: "You know what I'm saying",
      },
      {
        time: 197230,
        line: "오빤 강남스타일",
      },
      {
        time: 198840,
        line: "Eh- Sexy Lady",
      },
      {
        time: 204020,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 207650,
        line: "Eh- Sexy Lady",
      },
      {
        time: 211380,
        line: "오 오 오 오 오빤 강남스타일",
      },
      {
        time: 216760,
        line: "",
      },
    ],
  },
];
